import { SlotScheduleModel } from '../models/slots.model';
import RequestCreator from './helpers/requestCreator';

class SlotSchedulesApi extends RequestCreator<SlotScheduleModel> {}

const api = new SlotSchedulesApi('/slot-schedules');
export default api;
